<template>
  <v-form ref="mainForm" v-model="valid">
    <data-iterator
      :list="sas.equivalencesCours"
      add-new-text="Ajouter un cours"
      :live="{ endpoint: 'sas-equivalence-cours', sasId: sas.id, payload: { codeTypeCours: 'TH' } }"
      card-width="800"
      :icon="$getIcon('cours')"
      :valids="valids"
      ref="dataIterator"
    >
      <template v-slot:show-mode="{ item }">
        <h3 v-if="item.titre">{{ item.titre }}</h3>
        <p class="my-0" v-if="item.sigleOuNumero">{{ item.sigleOuNumero }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <opq-text-field code="numero-cours" v-model="item.sigleOuNumero" :live="liveSasCours(6802, item)" optional></opq-text-field>
        <opq-text-field code="titre-cours" v-model="item.titre" :live="liveSasCours(6803, item)"></opq-text-field>
        <opq-catalogue code="credits-cours" v-model="item.creditsAttribues" :live="liveSasCours(6804, item)"></opq-catalogue>
        <opq-text-field
          :opq-if="estOui(item.creditsAttribues)"
          code="nombre-credits-cours"
          v-model="item.nombreDeCredits"
          :live="liveSasCours(6805, item)"
          isNumber
        ></opq-text-field>
        <opq-text-field
          :opq-if="estNon(item.creditsAttribues)"
          code="nombre-heures-cours"
          v-model="item.nombreDHeures"
          :live="liveSasCours(6806, item)"
          isNumber
        ></opq-text-field>
        <opq-relation
          code="selection-releve-note-cours"
          v-model="item.releveDeNote"
          :live="liveSasCours(6807, item)"
          :list="relevesDeNotes"
        ></opq-relation>

        <opq-file-multiple code="description-cours" :files="item.descriptionOuPlanDeCours" :live="liveSasCours(6809, item)"></opq-file-multiple>
        <opq-catalogue code="categorie-theorique-cours" v-model="item.categorieTheorique" :live="liveSasCours(6813, item)" optional></opq-catalogue>
        <opq-alert v-show="codeRessourceDescCat(item.categorieTheorique)" :code="codeRessourceDescCat(item.categorieTheorique)"></opq-alert>
        <opq-memo code="pertinence-cours" v-model="item.pertinenceCours" :live="liveSasCours(6817, item)" optional></opq-memo>
      </template>
    </data-iterator>
  </v-form>
</template>

<script>
import FormHybrid from "@/mixins/FormHybrid"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormHybrid, CataloguesHelper],
  props: {
    sas: { type: Object }
  },
  data() {
    return {
      codeRessourceByCategorieTheorique: {
        "01": "desc-cat-modele-theorique",
        "02": "desc-cat-modele-theorique",
        "03": "desc-cat-modele-theorique",
        "04": "desc-cat-modele-theorique",
        "05": "desc-cat-modele-theorique",
        "06": "desc-cat-facteur-commun",
        "07": "desc-cat-outil-critique",
        "08": "desc-cat-classification",
        "09": "desc-cat-biologie",
        10: "desc-cat-aspect-legal",
        11: "desc-cat-ethique-deonto"
      }
    }
  },

  computed: {
    relevesDeNotes() {
      let releves = []
      this.sas.diplomes.forEach((diplome) => {
        diplome.relevesDeNotes
          .filter((r) => r.id && r.name && r.lien)
          .forEach((releve) => {
            releves.push(releve)
          })
      })
      return releves
    }
  },
  methods: {
    liveSasCours(cle, item) {
      return { endpoint: "sas-equivalence-cours", cle: cle, fileId: item.id }
    },
    codeRessourceDescCat(categorie) {
      return this.codeRessourceByCategorieTheorique[this.getCatalogueCodeById(6910, categorie)]
    }
  }
}
</script>

<style>
</style>